import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesMgmtComponent } from './roles-mgmt.component';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {TableModule} from 'primeng/table';
import {PaginatorModule} from 'primeng/paginator';
import {MenuModule} from 'primeng/menu';
import { AddEditRoleFormComponent } from './add-edit-role-form/add-edit-role-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import {DialogModule} from 'primeng/dialog';



@NgModule({
  declarations: [RolesMgmtComponent, AddEditRoleFormComponent],
    imports: [
        CommonModule,
        BreadcrumbModule,
        ToastModule,
        ButtonModule,
        RippleModule,
        TableModule,
        PaginatorModule,
        MenuModule,
        ReactiveFormsModule,
        InputTextModule,
        InputSwitchModule,
        CheckboxModule,
        DialogModule
    ]
})
export class RolesMgmtModule { }
